<div class="rcs-phone" data-testid="rcs-phone">
  <div class="rcs-phone__status"><span>9:41</span><span>5G <i class="fa fa-signal"></i></span></div>

  <div class="rcs-phone__head" *ngIf="view === 'rcs'">
    <span class="rcs-mono rcs-mono--round rcs-mono--sm" [style.--brand]="brand?.color || null">
      <img *ngIf="brand?.logo_url" [src]="brand.logo_url" alt="" />
      <ng-container *ngIf="!brand?.logo_url">{{ initial(brand?.name) }}</ng-container>
    </span>
    <div>
      <b>{{ brand?.name || 'Sua marca' }} <i class="fa fa-check-circle" title="Marca verificada"></i></b>
      <small>Marca verificada</small>
    </div>
  </div>
  <div class="rcs-phone__head" *ngIf="view === 'sms'">
    <span class="rcs-mono rcs-mono--round rcs-mono--sm">#</span>
    <div><b>Número curto</b><small>SMS</small></div>
  </div>

  <div class="rcs-phone__body">
    <ng-container *ngIf="view === 'sms'">
      <div class="rcs-bubble rcs-bubble--sms" data-testid="rcs-sms-text">{{ smsText || 'O SMS aparece aqui.' }}</div>
      <div class="rcs-phone__meta">{{ smsLength }}/160 · SMS</div>
    </ng-container>

    <ng-container *ngIf="view === 'rcs' && type === 'basic'">
      <div class="rcs-bubble" data-testid="rcs-basic-text">{{ text || 'O texto aparece aqui.' }}</div>
      <div class="rcs-phone__meta">{{ when }} · RCS</div>
    </ng-container>

    <ng-container *ngIf="view === 'rcs' && type === 'single'">
      <div class="rcs-richcard" data-testid="rcs-richcard">
        <div class="rcs-richcard__media" *ngIf="mediaUrl"><img [src]="mediaUrl" alt="" /></div>
        <div class="rcs-richcard__text"><b *ngIf="hasTitle">{{ title }}</b>{{ text }}</div>
        <ng-container *ngFor="let button of buttons; let i = index">
          <ng-container *ngIf="!interactive">
            <div class="rcs-richcard__button"><i class="fa" [ngClass]="icon(button.type)"></i> {{ button.label }}</div>
          </ng-container>
          <ng-container *ngIf="interactive">
            <a *ngIf="linkOf(button) as href; else action" class="rcs-richcard__button is-clickable" [href]="href" target="_blank"
              rel="noopener noreferrer" [title]="href" [attr.data-testid]="'rcs-phone-button-' + i">
              <i class="fa" [ngClass]="icon(button.type)"></i> {{ button.label }}
            </a>
            <ng-template #action>
              <button type="button" class="rcs-richcard__button is-clickable" (click)="press(button, i)"
                [attr.aria-expanded]="button.type === 'url' ? null : revealed === i" [attr.data-testid]="'rcs-phone-button-' + i">
                <i class="fa" [ngClass]="icon(button.type)"></i> {{ button.label }}
              </button>
            </ng-template>
            <div class="rcs-richcard__reveal" *ngIf="revealed === i" [attr.data-testid]="'rcs-phone-reveal-' + i">
              <ng-container *ngIf="button.type === 'call'">
                <i class="fa fa-phone"></i>
                <a *ngIf="telOf(button) as tel" [href]="tel">{{ button.target }}</a>
                <span *ngIf="!button.target">Sem telefone</span>
              </ng-container>
              <ng-container *ngIf="button.type === 'pix'">
                <span>{{ copied === i ? 'Código Pix copiado:' : 'Código Pix:' }}</span>
                <code>{{ button.target || '—' }}</code>
              </ng-container>
              <ng-container *ngIf="button.type === 'url'">
                <span>Link sem endereço válido: {{ button.target || '—' }}</span>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="rcs-phone__meta">{{ when }} · RCS</div>
    </ng-container>
  </div>
</div>
